import React from 'react';
import { Checkbox, ColorPicker, Input, Select, Slider } from 'antd';
import { FONT_OPTIONS } from '../../utils/mapDrawingBoard/constants';

/** 颜色 / 透明度 / 线宽 / 文字样式调色板 */
export default function DrawingSettingsPanel({
  tool,
  features,
  selectedIds,
  selectedFeature,
  drawColor,
  setDrawColor,
  drawOpacity,
  setDrawOpacity,
  sketchLineWidth,
  setSketchLineWidth,
  sketchPreviewColor,
  setSketchPreviewColor,
  textStyle,
  setTextStyle,
  textContent,
  setTextContent,
  patchSelectedFeature
}) {
  return (
    <div className="zhxt-draw-settings">
      {tool === 'sketch' ? (
        <>
          <div className="zhxt-draw-row">
            <span title="拖动画线时的临时颜色">预览色</span>
            <ColorPicker
              value={sketchPreviewColor}
              size="small"
              onChange={(_, hex) => setSketchPreviewColor(hex)}
            />
          </div>
          <div className="zhxt-draw-row">
            <span title="抬笔定型后的线条颜色；改选中手绘也会用此色">完成色</span>
            <ColorPicker
              value={drawColor}
              size="small"
              onChange={(_, hex) => setDrawColor(hex)}
            />
          </div>
        </>
      ) : (
        <div className="zhxt-draw-row">
          <span title="绘制中为橙色预览；右键/完成后切换为此颜色">完成色</span>
          <ColorPicker
            value={drawColor}
            size="small"
            onChange={(_, hex) => {
              setDrawColor(hex);
              setTextStyle((s) => ({ ...s, color: hex }));
            }}
          />
        </div>
      )}
      <div className="zhxt-draw-row">
        <span>透明度</span>
        <Slider
          min={0.2}
          max={1}
          step={0.05}
          value={drawOpacity}
          onChange={(v) => {
            setDrawOpacity(v);
            setTextStyle((s) => ({ ...s, opacity: v }));
          }}
          style={{ flex: 1, margin: '0 4px', padding: 0 }}
        />
        <span style={{ width: 30, textAlign: 'right', fontSize: 11 }}>{Math.round(drawOpacity * 100)}%</span>
      </div>
      {(tool === 'sketch' || features.some((f) => selectedIds.includes(f.id) && f.type === 'sketch')) && (
        <div className="zhxt-draw-row">
          <span>线宽</span>
          <Slider
            min={1}
            max={12}
            step={1}
            value={sketchLineWidth}
            onChange={setSketchLineWidth}
            style={{ flex: 1, margin: '0 4px', padding: 0 }}
          />
          <span style={{ width: 22, textAlign: 'right', fontSize: 11 }}>{sketchLineWidth}</span>
        </div>
      )}
      {(tool === 'text' || selectedFeature?.type === 'text') && (
        <div className="zhxt-draw-text-tools">
          <div className="zhxt-draw-row">
            <span>字体</span>
            <Select
              size="small"
              style={{ flex: 1, minWidth: 0 }}
              value={textStyle.fontFamily}
              options={FONT_OPTIONS}
              onChange={(fontFamily) => {
                setTextStyle((s) => ({ ...s, fontFamily }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ fontFamily });
              }}
            />
          </div>
          <div className="zhxt-draw-row">
            <span>字号</span>
            <Slider
              min={10}
              max={48}
              step={1}
              value={textStyle.fontSize}
              onChange={(fontSize) => {
                setTextStyle((s) => ({ ...s, fontSize }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ fontSize });
              }}
              style={{ flex: 1, margin: '0 4px', padding: 0 }}
            />
            <span style={{ width: 26, textAlign: 'right', fontSize: 11 }}>{textStyle.fontSize}</span>
          </div>
          <div className="zhxt-draw-row">
            <span>字距</span>
            <Slider
              min={-2}
              max={12}
              step={0.5}
              value={textStyle.letterSpacing}
              onChange={(letterSpacing) => {
                setTextStyle((s) => ({ ...s, letterSpacing }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ letterSpacing });
              }}
              style={{ flex: 1, margin: '0 4px', padding: 0 }}
            />
            <span style={{ width: 26, textAlign: 'right', fontSize: 11 }}>{textStyle.letterSpacing}</span>
          </div>
          <div className="zhxt-draw-row">
            <span>行距</span>
            <Slider
              min={1}
              max={2.4}
              step={0.1}
              value={textStyle.lineHeight}
              onChange={(lineHeight) => {
                setTextStyle((s) => ({ ...s, lineHeight }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ lineHeight });
              }}
              style={{ flex: 1, margin: '0 4px', padding: 0 }}
            />
            <span style={{ width: 26, textAlign: 'right', fontSize: 11 }}>{textStyle.lineHeight}</span>
          </div>
          <div className="zhxt-draw-row">
            <span>背景</span>
            <Checkbox
              checked={textStyle.bgEnabled !== false}
              onChange={(e) => {
                const bgEnabled = e.target.checked;
                setTextStyle((s) => ({ ...s, bgEnabled }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ bgEnabled });
              }}
            >
              显示
            </Checkbox>
            <ColorPicker
              value={textStyle.bgColor}
              size="small"
              disabled={textStyle.bgEnabled === false}
              onChange={(_, hex) => {
                setTextStyle((s) => ({ ...s, bgColor: hex }));
                if (selectedFeature?.type === 'text') patchSelectedFeature({ bgColor: hex });
              }}
            />
          </div>
          {tool === 'text' && !selectedFeature && (
            <Input.TextArea
              size="small"
              rows={2}
              value={textContent}
              placeholder="先写文字，再点地图放置"
              onChange={(e) => setTextContent(e.target.value)}
              style={{ marginTop: 4, fontSize: 11 }}
            />
          )}
        </div>
      )}
    </div>
  );
}
